import React from 'react';

class NoInternetConnection extends React.Component {
    render() {
        return (
            <div style={{display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                <h1>It seems that you are not connected to internet! Please check your internet connection.</h1>
            </div>
        )
    }
}

export default NoInternetConnection
